import { render, staticRenderFns } from "./DetailCekGadai.vue?vue&type=template&id=1b10ac1e&"
import script from "./DetailCekGadai.vue?vue&type=script&lang=js&"
export * from "./DetailCekGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports